import { useEffect, useState } from 'react';
import { useContainer } from '../../useContainer';
import { LeaveRequestApi } from '../../../api';
import { dispatch } from '../../../store';
import { addProfileLeaveRequestHistoryForExport } from '../../../store/slices/user-profile.slice';

const useHttpGetLeaveRequestHistoryForExport = (userSub: string) => {
    const leaveRequestApi = useContainer(LeaveRequestApi);
    const [isReady, setIsReady] = useState(false);

    const { exec, abort } = leaveRequestApi.getLeaveRequestsHistoryForUserProfileForExport({
        params: { userSub },
        onSuccess: res => {
            dispatch(addProfileLeaveRequestHistoryForExport(res.body));
        },
        onError: error => {
            console.error('Error fetching leave request history:', error);
        },
        onFinally: () => setIsReady(true),
    });

    useEffect(() => {
        if (!userSub) return;
        exec();
        return abort;
    }, [userSub, exec, abort]);

    return { exec, abort, isReady };
};

export default useHttpGetLeaveRequestHistoryForExport;
